import { useEffect, useRef, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import useGetPartyTypes from "../hooks/useGetPartyTypes";

const PartyInformationFields = () => {
  const { register, watch, setValue } = useFormContext();
  const { partyTypes } = useGetPartyTypes();

  const partyTypeRef = useRef(null);
  const [partyTypeOpen, setPartyTypeOpen] = useState(false);

  const partyType = watch("party_type_id");

  useEffect(() => {
    if (!partyTypeOpen) return;
    const onClick = (e) => {
      if (partyTypeRef.current && !partyTypeRef.current.contains(e.target)) {
        setPartyTypeOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [partyTypeOpen]);

  const selectedTypeName = partyTypes?.results?.find((t) => t.id === (partyType || 1))?.name ?? "";

  const dateField = {
    setValueAs: (v) => (v === "" || v === null ? null : v),
  };

  return (
    <Row className="mx-0 p-l-5 p-r-5 m-t-5">
      <Col md={12} className="p-0">
        <div className="row position-relative mx-0 align-items-center custom-margin-bottom">
          <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
            Type:
          </span>
          <div
            ref={partyTypeRef}
            className="dropdown-button d-flex-1 form-control p-0 p-l-5 rounded-0 height-25 d-flex custom-select-new-provider align-items-center"
            onClick={() => setPartyTypeOpen((prev) => !prev)}
            style={{ cursor: "pointer", position: "relative" }}
          >
            <span>{selectedTypeName}</span>
          </div>

          {partyTypeOpen && (
            <div
              className="dropdown-menu p-0 mt-0"
              style={{
                width: "638px",
                left: "150px",
                top: "25px",
                border: "1px solid #ced4da",
                maxHeight: "200px",
                overflowY: "auto",
                scrollbarWidth: "none",
                position: "absolute",
              }}
            >
              {partyTypes?.results?.map((type) => (
                <div
                  key={type.id}
                  className="dropdown-option height-25 d-flex align-items-center"
                  style={{ cursor: "pointer", paddingLeft: "5px", fontWeight: "600" }}
                  onMouseDown={() => {
                    setValue("party_type_id", type.id);
                    setPartyTypeOpen(false);
                  }}
                >
                  {type.name}
                </div>
              ))}
            </div>
          )}
        </div>

        <>
          <div className="row mx-0 align-items-center custom-margin-bottom">
            <span className="d-inline-block ps-0 white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
              Gender:
            </span>
            <div className="d-flex-1 custom-select-state-entity position-relative">
              <Form.Control
                as="select"
                className="form-control height-25 p-0 p-l-5 rounded-0"
                {...register("gender")}
              >
                <option value="">-----------</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </Form.Control>
            </div>
          </div>

          <div className="row mx-0 align-items-center custom-margin-bottom">
            <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
              SSN:
            </span>
            <div className="d-flex-1">
              <input
                type="text"
                placeholder="SSN"
                className="form-control p-l-5 p-0 height-25 rounded-0"
                {...register("ssn")}
              />
            </div>

            <span className="d-inline-block p-l-5 white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
              License Number:
            </span>
            <div className="d-flex-1">
              <input
                type="text"
                placeholder="Driving License Number"
                className="form-control p-l-5 p-0 height-25 rounded-0"
                {...register("driver_license")}
              />
            </div>
          </div>
        </>

        <div className="row mx-0 align-items-center custom-margin-bottom">
          <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
            Liability Acc %:
          </span>
          <div className="d-flex-1">
            <input
              type="number"
              step="any"
              className="form-control p-l-5 p-0 height-25 rounded-0"
              {...register("liability_percent")}
            />
          </div>
          <span className="d-inline-block p-l-5 white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
            Liability Est %:
          </span>
          <div className="d-flex-1">
            <input
              type="number"
              step="any"
              className="form-control p-l-5 p-0 height-25 rounded-0"
              {...register("liability_estimate")}
            />
          </div>
        </div>

        <div className="row mx-0 align-items-center custom-margin-bottom">
          <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
            Rep Letter:
          </span>
          <div className="d-flex-1">
            <input
              type="date"
              className="form-control p-l-5 p-0 height-25 rounded-0"
              {...register("repr_letter_sent", dateField)}
            />
          </div>
          <span className="d-inline-block p-l-5 white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
            Contact:
          </span>
          <div className="d-flex-1">
            <input
              type="date"
              className="form-control p-l-5 p-0 height-25 rounded-0"
              {...register("contact_date", dateField)}
            />
          </div>
        </div>

        <div className="row mx-0 align-items-center">
          <span className="d-inline-block ps-0 white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
            Served:
          </span>
          <div className="d-flex-1">
            <input
              type="date"
              className="form-control p-l-5 p-0 height-25 rounded-0"
              {...register("party_served_date", dateField)}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default PartyInformationFields;
